import React, { useState } from 'react';
import { CrossmintPayButton } from '@crossmint/client-sdk-react-ui';
//import * as anchor from '@project-serum/anchor';

/* eslint-disable react/prop-types */
/*const checkoutPropsJS = {
  display: "same-tab", // "same-tab" | "new-tab" | "popup"
}*/
export interface CrossmintProps {
  mode?: string;
  connection: boolean;
  wallet: string;
}
const CrossMint = (props: CrossmintProps) => {
  //states
  const [mintAmount, setMintAmount] = useState(1);
  //const mintAmountSingle = 1;
  const nftCost = 70;
  const projectId = process.env.REACT_APP_PROJECT_ID || '';
  const collectionId = process.env.REACT_APP_COLLECTION_ID || '';
  const clientId = process.env.REACT_APP_CLIENT_ID || '';
  //const ENV = process.env.REACT_APP_ENVIRONMENT || '';
  const handleDecrement = () => {
    if (mintAmount <= 1) return;
    setMintAmount(mintAmount - 1);
  };
  const handleIncrement = () => {
    if (mintAmount >= 3) return;
    setMintAmount(mintAmount + 1);
  };
  return (
    <div style={{ marginTop: '15px', marginBottom: '15px', width: '100%', display: 'flex', justifyContent: 'center', maxWidth: '500px' }}>
      {props.mode !== 'single' ? (
        <>
          <button onClick={handleDecrement}> - </button>
          <input readOnly type="number" value={mintAmount} />
          <button onClick={handleIncrement}> + </button>
          <CrossmintPayButton
            projectId={projectId}
            collectionId={collectionId}
            clientId={clientId}
            className="xmint-btn"
            /*environment={ENV}*/
            /*emailTo={"USER_EMAIL_"}  // OPTIONAL: provide if you want to specify the exact destination*/
            /*mintTo={props.wallet != null || props.wallet != undefined ? props.wallet : null }  // OPTIONAL: provide if you want to specify the exact destination*/
            //checkoutProps={checkoutPropsJS}
            mintConfig={{
              type: 'candy-machine',
              totalPrice: (nftCost * mintAmount).toString(),
              quantity: mintAmount, // The amount of NFTs you would like to mint per order.
              customString: 'my custom string'
            }}
          />
        </>
      ) : (
        <>
          {props.connection ? (
            <CrossmintPayButton
              projectId={projectId}
              collectionId={collectionId}
              className="xmint-btn"
              mintTo={props.connection && props.wallet !== '' ? props.wallet : ''} // OPTIONAL: provide if you want to specify the exact destination
              getButtonText={(connecting) => (connecting ? 'Connecting' : `MINT WITH CARD/SOL`)}
              /*environment={ENV}*/
              /*mintConfig={{
                type: "candy-machine",
                totalPrice: (nftCost * mintAmountSingle).toString(),
                quantity: mintAmountSingle, // The amount of NFTs you would like to mint per order.
                customString: (`${props.wallet != null || props.wallet != undefined ? "MINT WITH CREDIT CARD":""}`),
                //mintingGroup: "_MINTING_GROUP_" // only if you have configured minting groups in candy guards
              }}*/
            />
          ) : (
            <CrossmintPayButton
              projectId={projectId}
              collectionId={collectionId}
              className="xmint-btn"
              /*environment={ENV}*/
            />
          )}
        </>
      )}
    </div>
  );
};
export default CrossMint;
